import {Success} from 'presentation/pages/others/facial-biometrics/pages';
import React from 'react';

export const MakeSuccess: React.FC = () => <Success />;
